import {createSvgIcon} from './utils'

export default createSvgIcon(
  <>
    <path
      d="M0 20.502C0 9.45626 8.95431 0.501953 20 0.501953C31.0457 0.501953 40 9.45626 40 20.502C40 31.5476 31.0457 40.502 20 40.502C8.95431 40.502 0 31.5476 0 20.502Z"
      fill="#F5523A"
    />
    <path
      d="M23.32 11.502H16.68C16.42 11.502 16.16 11.612 15.98 11.792L11.29 16.482C11.11 16.662 11 16.922 11 17.182V23.812C11 24.082 11.11 24.332 11.29 24.522L15.97 29.202C16.16 29.392 16.42 29.502 16.68 29.502H23.31C23.58 29.502 23.83 29.392 24.02 29.212L28.7 24.532C28.89 24.342 28.99 24.092 28.99 23.822V17.182C28.99 16.912 28.88 16.662 28.7 16.472L24.02 11.792C23.84 11.612 23.58 11.502 23.32 11.502ZM20 25.802C19.28 25.802 18.7 25.222 18.7 24.502C18.7 23.782 19.28 23.202 20 23.202C20.72 23.202 21.3 23.782 21.3 24.502C21.3 25.222 20.72 25.802 20 25.802ZM20 21.502C19.45 21.502 19 21.052 19 20.502V16.502C19 15.952 19.45 15.502 20 15.502C20.55 15.502 21 15.952 21 16.502V20.502C21 21.052 20.55 21.502 20 21.502Z"
      fill="white"
    />
  </>,
  'Error',
)
